import React, { useState, useEffect } from 'react';

const DashboardHeader = () => {
  const [loadTime, setLoadTime] = useState('');

  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const timeString = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`;
    setLoadTime(timeString);
  }, []);

  return (
    <div className="bg-white px-6 py-8 border-b border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="flex-grow">
            <h1 className="text-3xl font-bold mb-3 text-blue-800">
              San Diego Homelessness Analytics
            </h1>

            <div className="space-y-2">
              <p className="text-gray-700 text-lg font-medium">
                Data-Driven Analysis of Homelessness in San Diego County
                </p>
              <p className="text-gray-600 max-w-3xl">
                A comprehensive dashboard analyzing homelessness trends and correlations 
                with socioeconomic factors in San Diego, providing real-time and historical insights
                to understand the dynamics of homelessness.
              </p>

              <div className="flex items-center gap-4 text-sm text-gray-500 mt-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                  <span>Last Updated: {loadTime}</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500"></div>
                  <span>Coverage: San Diego County</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-shrink-0 items-center gap-4">
            <img 
              src="/SD.png" 
              alt="San Diego Map" 
              className="h-24 w-auto object-contain opacity-80"
            />
            <a 
              href="https://www.sdsu.edu/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-90 transition-opacity"
            >
              <img 
                src="https://logos-world.net/wp-content/uploads/2022/11/SDSU-Symbol.png" 
                alt="SDSU Logo" 
                className="h-24 w-auto object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;